import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import isologo_SII from '../../../../../../../../assets/isologo_SII.png'
import iconNuevo from '../../../../../../../../assets/iconos/iconNuevo.png'
import translations from '../../../../../../ui/traslation/traslationAdministracion.json'
import clsx from 'clsx'
import { Text } from '../../../../../../ui'
import SearchIcon from '@mui/icons-material/Search'
import { useState } from 'react'
import { getCurrentDate } from '../../../../../../../utils/constant'
import { formatCurrency, formatDate, formatRut } from '../../../../../../../utils/formatter'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import { getStatusBadgeClass, getStatusLabel } from './statusBadge'

const getBaseDocumentAmount = row =>
  Number(
    row?.montoDocumentoBase ??
    (row?.nombreFolio === 'Boleta' ? row?.montoNetoLiquido : row?.montoTotal) ??
    0
  )

const getDisplayAmount = row => Number(row?.montoSeleccionable ?? getBaseDocumentAmount(row))

const TablaCajaPrincipal = ({rows,rowsPerPage,onSort, order,onSeleccionar,filasSeleccionadas}) => {
  //const [page] = useState(0)
  const [currentDate] = useState(getCurrentDate())

  const styles = {
    table: 'w-full table-auto text-[0.725rem] border-collapse leading-tight',
    thead: 'sticky top-0 z-10 bg-white',
    th: 'py-2 px-1 w-auto max-w-[120px] text-center break-words border-b border-gray-200',
    tr: 'border-b border-gray-200 hover:bg-gray-100/50',
    td: 'py-1 px-2 w-auto  max-w-[200px] text-center break-words align-top',
    smallCol: 'w-auto max-w-[80px]',
    wideCol: 'w-auto max-w-[300px]',
    boldText: 'font-bold text-[0.65rem]',
    text: 'text-[0.705rem] text-gray-500',
  }

  const orderableCols = [
    { col: '', field: null },
    { col: 'Folio', field: 'numeroFolio' },
    { col: 'Cliente', field: 'razonSocial' },
    { col: 'Fecha', field: 'fecha' },
    { col: 'Clasificación', field: 'nombreCuenta' },
    { col: 'Monto', field: 'montoSeleccionable' },
    { col: 'Status', field: 'status' },
    { col: 'Acciones', field: 'aprobado' }
  ]

  const obtenerAbreviatura = nombre => {
    return translations.documentosContables[nombre] || nombre // Si no encuentra la abreviatura, devuelve el nombre original.
  }

  if (!rows?.[0])
    return (
      <div className="flex flex-col items-center py-12">
        <SearchIcon fontSize="large" className="mb-4 text-gray-400" />
        <Text>{translations.tableAction.noData}</Text>
      </div>
    )
  else
  return (
      <div className='overflow-x-auto'>
        <div className='h-full mt-2'>
          <table className={styles.table}>
            <thead className={styles.thead}>
            <tr>
              {orderableCols.map(({ col, field }, i) => (
                <th key={i} 
                className={clsx(
                styles.th,
                { 'cursor-pointer': field },
                i === 0 && styles.smallCol
                )}
                onClick={() => field && onSort({ col, field })}>
                {col}
                {order.col === col && (
                  <KeyboardArrowDownIcon
                    className={clsx('transition-all ml-2 cursor-pointer', {
                    'opacity-40': order.col !== col,
                    'rotate-180': order.direction === 'desc'
                    })}
                  />
                )}
            </th>
            ))}
            </tr>
            </thead>
            <tbody>
             {rows.map((row, i) => {
              const estaSeleccionado = filasSeleccionadas?.includes(row.id)
              const montoBase = getBaseDocumentAmount(row)
              const montoDisplay = getDisplayAmount(row)
              const muestraSaldoPendiente = montoDisplay !== montoBase
             return(
              <tr className={clsx(styles.tr)} key={i}>
                <td className={clsx(styles.td, styles.smallCol)}>
                  <div className="flex items-center justify-center gap-2">
                    <input type="checkbox" className="rounded" checked={filasSeleccionadas.includes(row.id)} onChange={() => onSeleccionar?.(row)}/>
                    <div className="relative">
                      <img src={isologo_SII} className="min-w-5 h-5" />
                      {currentDate === formatDate(rows.fecha) && (
                        <img
                          src={iconNuevo}
                          className="absolute -top-2 left-4 w-4 h-4 opacity-60"
                        />
                      )}
                    </div>
                  </div>
                </td>
                {/* Folio */}
                <td className={styles.td}>
                  <Text className={styles.boldText}>{obtenerAbreviatura(row.nombreFolio)}</Text>
                  <Text className={styles.text}>{row.numeroFolio}</Text>
                </td>
                {/* Cliente */}
                <td className={clsx(styles.td)}>
                  <Text className={styles.boldText}>{row.razonSocial || '<Razon Social>'}</Text>
                  <Text className={styles.text}>
                    {(row.rut && formatRut(row.rut)) || '<RUT>'}
                  </Text>
                </td>
                {/* Fecha */}
                <td className={styles.td}>
                    <Text className={styles.boldText}>{row.fecha && formatDate(row.fecha)}</Text>
                    <Text className={styles.text}>
                      {row.fechaVencimiento && formatDate(row.fechaVencimiento)}
                    </Text>
                    <Text className={styles.text}>{row.diasHastaVencimiento}</Text>
                </td>
                {/* Clasificacion */}
                <td className={styles.td} style={{ position: 'relative' }}>
                    <Text className={styles.boldText}>{row.nombreCuenta}</Text>
                    <Text className={styles.text}>{row.codigoCuenta}</Text>
                    <Text className={styles.text}>
                      {row.comprobante || 'ID'}
                      {' @' + (row.usuarioClasificador || 'TryLuca')}
                    </Text>
                </td>
                {/* Monto */}
                <td className={styles.td}>
                    {row.nombreFolio === 'Boleta' ? (
                      <>
                        <Text className={clsx(styles.boldText, 'text-xs text-right font-bold')}>
                          {formatCurrency(montoDisplay)}
                        </Text>
                        {muestraSaldoPendiente && (
                          <Text className='text-right text-gray-500'>
                            Total documento: {formatCurrency(montoBase)}
                          </Text>
                        )}
                        <Text className='text-right text-accent3'>
                          Retención: {formatCurrency(row.montoIvaRetenido)}
                        </Text>
                        <Text className='text-right text-gray-500'>
                          Total Honorario: {formatCurrency(row.montoTotal)}
                        </Text>
                      </>
                    ) : (
                      <>
                        <Text className={clsx(styles.boldText, 'text-xs  text-right font-bold')}>
                          {formatCurrency(montoDisplay)}
                        </Text>
                        {muestraSaldoPendiente && (
                          <Text className='text-right text-gray-500'>
                            Total documento: {formatCurrency(montoBase)}
                          </Text>
                        )}
                        <Text className='text-right text-accent3'>
                          IVA: {formatCurrency(row.montoIvaRetenido)}
                        </Text>
                        {(row.montoNetoLiquido !== 0 || row.montoExento == null) && (
                          <Text className='text-right text-gray-500'>
                            Neto: {formatCurrency(row.montoNetoLiquido)}
                          </Text>
                        )}
                      </>
                    )}
                    {row.montoExento != null && row.montoExento !== 0 && (
                      <Text className='text-xs text-right text-gray-500'>
                        Exento: {formatCurrency(row.montoExento)}
                      </Text>
                    )}
                </td>
                {/* Status */}
                <td className={styles.td}>
                    <Text className={getStatusBadgeClass(row.status)}>
                      {getStatusLabel(row.status)}
                    </Text>
                </td>
                <td>
                  <div className='flex h-full items-center justify-center space-x-3'>
                    <div
                      className='flex flex-col text-xs text-gray-500 items-center justify-center hover:cursor-pointer'
                      onClick={() => onSeleccionar?.(row)}
                    >
                      <button
                        className={clsx(
                          'flex items-center justify-center w-7 h-7 rounded-full shadow-full-xs transition-colors duration-150',
                          {
                            'bg-accent2 text-white hover:bg-accent2/90 cursor-pointer': estaSeleccionado,
                            'bg-gray-100 text-gray-300 hover:bg-gray-200 cursor-pointer': !estaSeleccionado,
                          }
                        )}
                      >
                        <DoneAllIcon className="w-4 h-4" />
                      </button>
                      <Text className='mt-2'>
                        {estaSeleccionado ? 'Seleccionado' : 'Seleccionar'}
                      </Text>
                    </div>
                  </div>
                </td>
              </tr>
             )
            })}
            </tbody>
        </table>
      </div>
      </div>
    )
}

export default TablaCajaPrincipal
